module.exports = __webpack_public_path__ + "img/보라매역 맛집.c8306547.png";